import audi from "./images/clients/1.png";
import hyundai from "./images/clients/2.png";
import client3 from "./images/clients/3.png";
import sugandha from "./images/clients/4.png";
import consumernews from "./images/clients/5.png";
import photoexposure from "./images/clients/6.png";
import aasraa from "./images/clients/7.png";
import avst from "./images/clients/8.png";
import flamingo from "./images/clients/9.png";
import apdc from "./images/clients/10.png";
import apsfl from "./images/clients/11.png";
import navaldockyard from "./images/clients/12.png";
import gmrit from "./images/clients/13.png";
import hitechi from "./images/clients/14.png";
import gitam from "./images/clients/15.png";

export const clientsLogos = [
    {
        clientImg: audi,
        clientName: "audi"
    },
    {
        clientImg: hyundai,
        clientName: "hyundai"
    },
    {
        clientImg: client3,
        clientName: "hyundai"
    },
    {
        clientImg: sugandha,
        clientName: "sugandha"
    },
    {
        clientImg: consumernews,
        clientName: "consumernews"
    },
    {
        clientImg: photoexposure,
        clientName: "photoexposure"
    },
    {
        clientImg: aasraa,
        clientName: "aasraa"
    },
    {
        clientImg: avst,
        clientName: "avst"
    },
    {
        clientImg: flamingo,
        clientName: "flamingo"
    },
    {
        clientImg: apdc,
        clientName: "apdc"
    },
    {
        clientImg: apsfl,
        clientName: "apsfl"
    },
    {
        clientImg: navaldockyard,
        clientName: "navaldockyard"
    },
    {
        clientImg: gmrit,
        clientName: "gmrit"
    },
    {
        clientImg: hitechi,
        clientName: "hitechi"
    },
    {
        clientImg: gitam,
        clientName: "gitam"
    },
]